export default __webpack_public_path__ + "static/media/img31.5201c7f5.jpg";